(ns ui.view.transaction-process.cards.transaction-teams
  (:require
   [re-frame.core :as rf]
   [ui.editors.data-input :as data-input]
   [ui.view.transaction-process.cards.card-header :as card-header]
   [ui.view.transaction-process.event :as event]
   [ui.view.transaction-process.sub :as sub]))

(defn- team-role-section
  [{:keys [team-role members on-change read-only?]}]
  [:div {:class "border border-gray-200 rounded-lg p-4"}
   [:label {:class "text-sm m-0 font-medium text-gray-900 mb-1 block"}
    (:team-role/label team-role)]
   [data-input/view
    {:editor-type        :editor.type/search
     :data-type          :data.type/ref-multi
     :field/entity-types [:entity.type/account]
     :field/os-filter-terms-fn (fn [_] {"extras.active-user" true})
     :value              members
     :on-change          (when-not read-only? on-change)
     :disabled?          read-only?
     :full-width?        true}]])

(defn view
  [{:keys [card template ctx]}]
  (let [team-roles (:template/team-roles template)
        team-assignments @(rf/subscribe [::sub/team-assignments ctx])
        read-only? @(rf/subscribe [::sub/effective-read-only?])]
    [:div {:class "bg-white rounded-lg border border-gray-200 p-6"}
     [card-header/view {:card card}]
     [:div {:class "flex flex-col gap-3"}
      (doall
       (for [role team-roles]
         (let [role-id (:team-role/id role)]
           ^{:key role-id}
           [team-role-section
            {:team-role  role
             :members    (get team-assignments role-id [])
             :read-only? read-only?
             :on-change  (fn [_ids options]
                           (let [option-vals (or options [])
                                 updated (assoc team-assignments role-id option-vals)]
                             (rf/dispatch [::event/update-draft-field ctx
                                           :transaction-process/team-assignments-edn
                                           updated])))}])))]]))
